export default __webpack_public_path__ + "static/role_2-3cd41d37e62aa86bf1a23034d57081d7.png";